/**
 * Validação de entrada livre por passo URA (espelha uraStepInputValidation.js na API).
 */

export const VALIDACAO_RESPOSTA_NONE = "";
export const VALIDACAO_RESPOSTA_NUMERO_RANGE = "numero_range";

export const VALIDACAO_RESPOSTA_TYPES = [
  VALIDACAO_RESPOSTA_NONE,
  "nome",
  "cpf",
  "cnpj",
  "documento",
  "celular",
  "telefone",
  "email",
  "data_nascimento",
  "data_livre",
  "data_futura",
  "numero",
  "numero_positivo",
  VALIDACAO_RESPOSTA_NUMERO_RANGE,
  "uf",
  "cidade",
  "texto",
];

export const VALIDACAO_RESPOSTA_LABEL_KEYS = {
  "": "none",
  nome: "nome",
  cpf: "cpf",
  cnpj: "cnpj",
  documento: "documento",
  celular: "celular",
  telefone: "telefone",
  email: "email",
  data_nascimento: "dataNascimento",
  data_livre: "dataLivre",
  data_futura: "dataFutura",
  numero: "numero",
  numero_positivo: "numeroPositivo",
  numero_range: "numeroRange",
  uf: "uf",
  cidade: "cidade",
  texto: "texto",
};

const VALIDACAO_ALIASES = {
  cidades: "cidade",
  data: "data_livre",
  data_maior_hoje: "data_futura",
  data_maior_que_hoje: "data_futura",
  data_partir_hoje: "data_futura",
  data_a_partir_hoje: "data_futura",
  numeros: "numero",
  numero_livre: "numero",
  numero_maior_que_zero: "numero_positivo",
  numero_maior_que_0: "numero_positivo",
  numero_intervalo: VALIDACAO_RESPOSTA_NUMERO_RANGE,
  numero_faixa: VALIDACAO_RESPOSTA_NUMERO_RANGE,
};

export function normalizeValidacaoResposta(raw) {
  const key = String(raw || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (!key || key === "none" || key === "nenhuma") return VALIDACAO_RESPOSTA_NONE;
  const resolved = VALIDACAO_ALIASES[key] || key;
  return VALIDACAO_RESPOSTA_TYPES.includes(resolved) ? resolved : VALIDACAO_RESPOSTA_NONE;
}

export function normalizeOptionalNumber(raw) {
  if (raw == null || raw === "") return null;
  const n = Number(String(raw).trim().replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function parseUrlapiJson(rawUrl) {
  if (rawUrl == null || rawUrl === "") return null;
  const str = String(rawUrl).trim();
  if (!str.startsWith("{") && !str.startsWith("[")) return null;
  try {
    const parsed = JSON.parse(str);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function validationConfigFromSlot(slot) {
  const fromUrlapi = parseUrlapiJson(slot?.urlapi);
  const nested =
    fromUrlapi?.validacao_numero && typeof fromUrlapi.validacao_numero === "object"
      ? fromUrlapi.validacao_numero
      : null;

  const minRaw =
    slot?.validacao_numero_min ??
    fromUrlapi?.validacao_numero_min ??
    nested?.min ??
    nested?.minimo ??
    null;
  const maxRaw =
    slot?.validacao_numero_max ??
    fromUrlapi?.validacao_numero_max ??
    nested?.max ??
    nested?.maximo ??
    null;

  return {
    validacao_resposta: normalizeValidacaoResposta(
      slot?.validacao_resposta ?? fromUrlapi?.validacao_resposta
    ),
    validacao_numero_min: normalizeOptionalNumber(minRaw),
    validacao_numero_max: normalizeOptionalNumber(maxRaw),
  };
}

export const VALIDACAO_CADASTRO_LOOKUP_TYPES = new Set([
  "cpf",
  "cnpj",
  "documento",
  "celular",
  "telefone",
  "email",
]);

export function validacaoRespostaFromSlot(slot) {
  return validationConfigFromSlot(slot).validacao_resposta;
}

export function verificarCadastroFromSlot(slot) {
  const fromUrlapi = parseUrlapiJson(slot?.urlapi);
  const raw = slot?.verificar_cadastro ?? fromUrlapi?.verificar_cadastro ?? fromUrlapi?.verificarCadastro;
  if (raw === true || raw === 1 || raw === "1") return true;
  const s = String(raw || "")
    .trim()
    .toLowerCase();
  return s === "true" || s === "sim" || s === "yes";
}

export function validationSupportsCadastroLookup(type) {
  return VALIDACAO_CADASTRO_LOOKUP_TYPES.has(normalizeValidacaoResposta(type));
}

/** Passos só com botões de menu (sem entrada livre) não precisam desta opção. */
export function slotExpectsFreeTextInput({ identificador, replyButtonCount = 0 } = {}) {
  const ident = String(identificador || "").trim();
  if (ident === "Exceção") return false;
  if (!ident) return true;
  return replyButtonCount === 0;
}
